import api from './api';

const dfr = {
  overview: (caseId, days = 365) =>
    api.get('/dfr/overview', {
      params: {
        ...(caseId ? { case_id: caseId } : {}),
        days,
      },
    }),
  timeline: (caseId, params = {}) =>
    api.get('/dfr/timeline', { params: { case_id: caseId, days: 365, ...params } }),
  clientFindings: (caseId, params = {}) =>
    api.get('/dfr/client-findings', { params: { case_id: caseId, ...params } }),
  createClientFinding: (data) => api.post('/dfr/client-findings', data),
  updateClientFinding: (id, data) => api.patch(`/dfr/client-findings/${id}`, data),
  meta: () => api.get('/dfr/meta'),
  clients: () => api.get('/dfr/clients'),
  createClient: (data) => api.post('/dfr/clients', data),
  client: (id) => api.get(`/dfr/clients/${id}`),
  updateClient: (id, data) => api.patch(`/dfr/clients/${id}`, data),
  subjects: (clientId) =>
    api.get('/dfr/subjects', { params: clientId ? { client_id: clientId } : {} }),
  createSubject: (data) => api.post('/dfr/subjects', data),
  cases: (params) => api.get('/dfr/cases', { params }),
  createCase: (data) => api.post('/dfr/cases', data),
  case: (id, params) => api.get(`/dfr/cases/${id}`, { params }),
  updateCase: (id, data) => api.patch(`/dfr/cases/${id}`, data),
  caseScans: (caseId) => api.get(`/dfr/cases/${caseId}/scans`),
  startScan: (caseId) => api.post(`/dfr/cases/${caseId}/scans`, {}),
  scan: (scanId) => api.get(`/dfr/scans/${scanId}`),
  reviewScanResult: (resultId, data) => api.post(`/dfr/scan-results/${resultId}/review`, data),
  brokers: () => api.get('/dfr/brokers'),
  createBroker: (data) => api.post('/dfr/brokers', data),
  updateBroker: (id, data) => api.patch(`/dfr/brokers/${id}`, data),
  exposures: (caseId, params = {}) =>
    api.get('/dfr/exposures', { params: { ...(caseId ? { case_id: caseId } : {}), ...params } }),
  createExposure: (data) => api.post('/dfr/exposures', data),
  operations: (params) => api.get('/dfr/operations', { params }),
  createOperation: (data) => api.post('/dfr/operations', data),
  updateOperation: (id, data) => api.patch(`/dfr/operations/${id}`, data),
  evidence: (caseId, params = {}) =>
    api.get('/dfr/evidence', { params: { ...(caseId ? { case_id: caseId } : {}), ...params } }),
  uploadEvidence: (formData) => api.post('/dfr/evidence', formData),
  sweeps: (caseId, params = {}) =>
    api.get('/dfr/sweeps', { params: { ...(caseId ? { case_id: caseId } : {}), ...params } }),
  createSweep: (data) => api.post('/dfr/sweeps', data),
  reports: (caseId) =>
    api.get('/dfr/reports', { params: caseId ? { case_id: caseId } : {} }),
  createReport: (data) => api.post('/dfr/reports', data),
  report: (id) => api.get(`/dfr/reports/${id}`),
};

export default dfr;
